module.exports = __webpack_public_path__ + "img/icon-useroverviewAsset 42.83ed18f9.svg";